/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABY0lEQVR4nOVUS0oDURDMRjyBH0TXOYEHUBCC2J+3mHSBrrN3obmBqCfwCgkBr6AJnsG96C6Kih9EMfJmBk2IM5lxMisbevMer6q6umYqlX9RIrbCah1SPPpmtVPmoDo1cBLcsmIw2nbn7woTsFpnHDxuQbswAYWWJBCoPZRKQIL7wgTsF5pokbWKE3BQ9QsdV29957aXK1OLqaDtPQ9brDU18FLLqySxJinOSe2GBB+seCfFFYudMWN3MwgWcwPXarVZVjtisdfkiH73dT7wIJgjxUUG4EH8LexlBm80GjPh6JnBMSDCgn8bihLrpRKEtuQBF+v/vI3OUheaxXMSvJFgnxlLo+ImEPi0ZFTd/H36SQSK7tAv4DKRhCPlmYIwvBOf8zgVT+SwnvTIuZ35ULFYb+K0iu6QRXiJDu2Eub6WourgTxax4pAVz1uuvkoOG6z4TFn0cW6ColU+gVhvxPO4vgBDJJvAcUG2tQAAAABJRU5ErkJggg==)
 */
export const UserPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.83 12.93c.26-.27.26-.75-.08-.92A9.5 9.5 0 0 0 12.47 11h-.94A9.53 9.53 0 0 0 2 20.53c0 .81.66 1.47 1.47 1.47h.22c.24 0 .44-.17.5-.4.29-1.12.84-2.17 1.32-2.91.14-.21.43-.1.4.15l-.26 2.61c-.02.3.2.55.5.55h7.64c.12 0 .17-.31.06-.36C12.82 21.14 12 20.22 12 19a3 3 0 0 1 3-3h.5a.5.5 0 0 0 .5-.5V15c0-.8.31-1.53.83-2.07ZM12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        className={colorClass}
      />
    </svg>
  );
};
